<template>
	<div class="study">
		<div v-if="active_study" class="study-content">

			<div class="row row-boxes">
				<transition name="fade">
					<div v-if="!editing" class="col col-sidebar">

						<sidebar :readonly="active_study_is_published" />

						<div class="study-dates">
							<div class="row">
								<div class="col half">
									<div class="study-date">
										<p class="label">Dernière sauvegarde :</p>
										<p><span class="value">Le {{ last_save_date }}</span></p>
										<!-- <div class="hover">
											<icon file="rotate-cw" :size="24" />
											<span>Enregistrer les modifications</span>
										</div> -->
									</div>
								</div>
								<template v-if="display_template">
									<div class="col half">
										<div class="study-date" :class="{'refresh-qlik': refreshing_stats}">
											<p class="label">Données calculées (QLIK) :</p>
											<p><span class="value">Le {{ statistical_data_date }}</span></p>
											<div class="hover" @click="refresh_stats_data">
												<icon file="rotate-cw" :size="24" :class="{'rotate': refreshing_stats}" />
												<span>Mettre à jour les données calculées</span>
											</div>
										</div>
									</div>
									<div v-if="active_study.segment.code === 'SCPI'" class="col q-mt-md half">
										<div class="study-date" :class="{'refresh-qlik': refreshing_kyaneos}">
											<p class="label">Données calculées (KYANEOS) :</p>
											<p><span class="value">Le {{ kyaneos_data_date }}</span></p>
											<div class="hover" @click="refresh_kyaneos_data">
												<icon file="rotate-cw" :size="24" :class="{'rotate': refreshing_kyaneos}" />
												<span>Mettre à jour les données calculées</span>
											</div>
										</div>
									</div>
									<div v-if="active_study.segment.code === 'SCPI'" class="col q-mt-md half">
										<div class="study-date" :class="{'refresh-qlik': refreshing_yanport}">
											<p class="label">Données calculées (YANPORT) :</p>
											<p><span class="value">Le {{ yanport_data_date }}</span></p>
											<div class="hover" @click="refresh_yanport_data">
												<icon file="rotate-cw" :size="24" :class="{'rotate': refreshing_yanport}" />
												<span>Mettre à jour les données calculées</span>
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>

					</div>
				</transition>
				<div class="col" :class="{editing: editing, 'col-editor': display_template, 'col-static': !display_template}">
					<div class="box" :class="{'box-editor': display_template}">
						<div class="content">

							<div v-if="display_template" class="scroll-wrap">
								<div class="scroll v-bar-light" v-bar>
									<div class="scroll-content" ref="scrollable">

										<div class="pages">
											<page name="editor_comment" />
											<page name="garde" :index="0" v-if="active_study.segment.code != 'GIE' && active_study.segment.code != 'SCPI'" />
											<page
												v-for="(section, index) in sections"
												:name="section.slug"
												:index="index + 1"
												:key="'pages-' + section.slug"
											/>
										</div>

									</div>
								</div>
							</div>
							<div class="" v-else>
								<static-study />
							</div>

							<div class="user-menu">

								<div class="save-button">
									<div class="button-content">
										<div class = "info save-btn" :class="save_icon_style">
											<icon file="save" :size="32" />
										</div>
									</div>
								</div>

								<div v-if="display_template && !active_study_is_published" class="mode-button" :class="{ 'show-back': editor.mode == 'viewing' }">
									<div class="button-content">
										<div class="back button light" @click="set_mode('editing')">
											<icon file="edit" :size="32" />
										</div>
										<div class="front button light" @click="set_mode('viewing')">
											<icon file="eye" :size="32" />
										</div>
									</div>
									<div class="tooltip">
										<span v-show="editor.mode == 'viewing'">Éditer l'étude</span>
										<span v-show="editor.mode == 'editing'">Visualiser l'étude</span>
									</div>
								</div>
								<div v-if="display_template && !active_study_is_published" class="print-button" :class="{ 'show-back': study.saving||save_is_required	}">
									<div class="button-content">
										<div class="back button low-opacity" >
											<icon file="printer" :size="32" />
											<div class="button-loader"><icon file="loader" :size="32" /></div>
										</div>
										<div class="front button green" @click="print_study()">
											<icon file="printer" :size="32" />
											<div class="button-loader"><icon file="loader" :size="32" /></div>
										</div>
									</div>
									<div class="tooltip">
										<span v-show="!(study.saving||save_is_required)">Imprimer</span>
										<span v-show="study.saving||save_is_required">Attendez...</span>
									</div>
								</div>
								<div class="mode-button" v-if="has_pdf" :class="{ 'show-back': !active_study_is_published  }">
									<div  class="button-content">
										<div v-if="study.saving||save_is_required"  class="back button green readonly">
											<icon file="rss" :size="32" />
											<div class="button-loader"><icon file="loader" :size="32" /></div>
										</div>
										<div v-else  class="back button green" @click="publish_study">
											<icon file="rss" :size="32" />
											<div class="button-loader"><icon file="loader" :size="32" /></div>
										</div>
										
										
										<div class="front button blue" @click="unpublish">
											<icon file="edit" :size="32" />
											<div class="button-loader"><icon file="loader" :size="32" /></div>
										</div>
									</div>
									<div class="tooltip">
										<span v-show="!active_study_is_published">Publier</span>
										<span v-show="active_study_is_published">Ré-éditer</span>
									</div>
								</div>
							</div>

							<div class="pdf-menu">
								<div v-if="has_pdf" class="button button-pdf">
									<a :href="secure_pdfLien" target=_blank>
										<icon file="button-pdf" :size="48" folder="" />
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			
			<transition name="mode-switcher">
				<div class="mode-switcher-info" v-if="show_switcher_info">
					<span v-if="editor.mode == 'viewing'">Mode visualisation activé</span>
					<span v-if="editor.mode == 'editing'">Mode édition activé</span>
				</div>
			</transition>

			<q-dialog v-model="study.publication_in_progress" persistent>
					<q-card>
						<q-card-section class="row items-center card-publication">
							<div class="loading-pub-study">
								<icon class="rotate" file="loader" :size="32" />
								<p class="main">Publication en cours...</p>
								<p class="sub">L'étude est en train d'être publiée (Portail CDC, Evalis et Zoho)</p>
							</div>
						</q-card-section>
					</q-card>
			</q-dialog>
			<q-dialog v-model="study.publication_failed" persistent>
					<q-card>
						<q-card-section class="row items-center card-publication">
							<div class="loading-pub-study">
								<icon class="failed" file="help-circle" :size="32" />
								<p class="main">La publication a échouée!</p>
								<p class="sub">{{study.publication_message}}</p>
								<div class="button" @click="unlock_modal">
									<p>OK</p>
								</div>
							</div>
						</q-card-section>
					</q-card>
			</q-dialog>
		</div>
		<div v-else class="study-loading"><icon file="loader" :size="40" /></div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { Bus } from "@/Bus";
import Page from "@/components/study/editor/page";
import Sidebar from "@/components/study/sidebar";
import StaticStudy from "@/components/study/static-study";
import $ from "jquery";
import moment from "moment";
import _ from "lodash";
import StudyMixin from "@/components/study/study.mixin.js";

moment.locale("fr");

export default {
	name: "study",
	mixins: [StudyMixin],
	data: function () {
		return {
			more_menu: false,
			show_switcher_info: false,
			refreshing_stats: false,
			refreshing_kyaneos: false,
			refreshing_yanport: false,
			save_interval: undefined
		};
	},
	computed: {
		...mapGetters([ "app", "app_parameters", "study", "editor", "active_project", "active_study", "active_study_is_published", "user_details", "display_template", "user" ]),
		statistical_data_date () {
			return moment(this.active_study.etudeData.statistical_data_date).format("DD MMMM YYYY à HH:mm:ss");
		},
		kyaneos_data_date () {
			return moment(this.active_study.etudeData.kyaneos_data_date).format("DD MMMM YYYY à HH:mm:ss");
		},
		yanport_data_date () {
			return moment(this.active_study.etudeData.yanport_data_date).format("DD MMMM YYYY à HH:mm:ss");
		},
		last_save_date () {
			return moment(this.active_study.etudeData.last_save_date).format("DD MMMM YYYY à HH:mm:ss");
		},
		has_pdf () {
			return (this.active_study.pdfLien && this.active_study.pdfLien.length > 0);
		},
		editing () {
			return this.editor.mode === "editing";
		},
		interval_duration () {
			return this.app_parameters == undefined ? process.env.VUE_APP_INTERVAL_SAVE : this.app_parameters.save_interval;
		},
		save_is_required () {
			return (this.study.required != 0);
		},
		save_icon_style (){
			if(this.study.last_save_failed || this.study.offline){
				return "red";
			}
			else if(this.study.saving || this.save_is_required){
				return "orange";
			}
			else{
				return "green";
			}
		},
		secure_pdfLien(){
			return this.active_study.pdfLien+"?token="+this.user.token;
		}
	},
	watch: {
		"editor.mode": function () {
			const that = this;
			that.show_switcher_info = true;
			setTimeout(function () {
				that.show_switcher_info = false;
			}, 1500);
		},
		"editor.scroll_to_section": function (newValue) {
			if (newValue) {
				const self = this;
				const $scrollable = $(this.$refs.scrollable);
				const $page = $(".study .page#section-" + newValue.slug);
				if ($page.length) {
					// $scrollable.animate({ scrollTop: $page[0].offsetTop - 16 }, 500)
					//FIX JNA : need a fix from design refacto
					$scrollable.animate({ scrollTop: $page[0].offsetParent.offsetTop }, 500);
					setTimeout(function () {
						self.$store.dispatch("scroll_to_section :", { section: false });
					}, 500);
				}
			}
		},
		"study.changed": function (newValue) {
			const self = this;
			if(newValue == true && self.save_interval == undefined){
				// self.save_interval = window.setInterval(function() {
				self.save_study();
				// }, self.interval_duration)
			}
		},
		"active_study": function (newValue) {
			if( newValue ){
				const lastUserId = typeof this.active_study.etudeData.last_save_user_id == "undefined" ? this.user_details.id : this.active_study.etudeData.last_save_user_id;
				if( this.user_details.id != lastUserId ){
					const currentDate = new Date();
					const lastUpdateDate = new Date(moment(this.active_study.etudeData.last_save_date));
					const timeSinceLastUpdate = Math.floor( (currentDate - lastUpdateDate) / 60000 );
					if( timeSinceLastUpdate < 5 ){
						alert(`La dernière modification sur cette étude a été réalisée il y a ${timeSinceLastUpdate == 0 ? "moins d'une " : timeSinceLastUpdate} minute${timeSinceLastUpdate > 1 ? "s" : ""}.\nIl est possible que quelqu'un soit en train d'éditer cette étude.\nSi ce n'est pas vous et que vous éditez cette étude, des problèmes de sauvegarde pourraient avoir lieux.`);
					}
				}
				//reresh Qlik data if needed
				if(newValue.etudeData && !!newValue.etudeData.refreshQlikData){
					this.refreshing_stats = true;
					this.refresh_stats_data();
				}
				//refresh Kyaneos data if needed
				if(newValue.etudeData && !!newValue.etudeData.refreshKyaneosData){
					this.refreshing_kyaneos = true;
					this.refresh_kyaneos_data();
				}

				//refresh Yanport data if needed
				if(newValue.etudeData && !!newValue.etudeData.refreshYanportData){
					this.refreshing_yanport = true;
					this.refresh_yanport_data();
				}
			}
		}
	},
	methods: {
		set_mode: function (mode) {
			this.$store.dispatch("set_mode", { mode: mode });
		},
		save_study: function () {
			if(this.study.changed){
				this.$store.dispatch("save_study");
			}
		},
		print_study: function () {
			//let route = this.$router.resolve({ name: 'print', params: { id: this.$route.params.id }});
			//window.open(route.href, '_blank');
			// console.log("clicked")
			
			// force "readonly" mode!
			this.set_mode("viewing");
			this.$router.push({ name: "print", params: { id: this.$route.params.id }});
		},
		reload_study: function () {
			this.$store.dispatch("set_active_study", { active_study: false });
			this.$nextTick(function () {
				this.$store.dispatch("load_study", { id: this.$route.params.id });
			});
		},
		async refresh_stats_data () {
			this.refreshing_stats = true;
			await this.$store.dispatch("refresh_stat_data");
			this.refreshing_stats = false;
		},
		async refresh_kyaneos_data () {
			this.refreshing_kyaneos = true;
			await this.$store.dispatch("refresh_kyaneos_data", { id: this.active_project.customGeoDetails.kyaneos.Guid });
			this.refreshing_kyaneos = false;
		},
		async refresh_yanport_data () {
			this.refreshing_yanport = true;
			await this.$store.dispatch("refresh_yanport_data", { codeInsee: this.active_project.adresse.codeInsee });
			this.refreshing_yanport = false;
		},
		publish_study () {
			if(this.active_study.evalisReference && this.active_study.evalisReference.trim().length > 0){
				if( window.confirm("Souhaitez-vous publier l'étude ?")) {
					this.set_mode("viewing");
					this.$store.dispatch("publish_active_study");
				}
			}else{
				this.$store.dispatch("code_evalis_failed");
			}
			
		},
		unpublish () {
			if( window.confirm("Souhaitez-vous ré-éditer l'étude ?")) {
				this.$store.dispatch("unpublish_active_study");
			}
		},
		unlock_modal () {
			this.$store.dispatch("unlock_modal");
		}
	},
	mounted: function () {
		const that = this;
		//set booelen to inform qlik data are refreshing
		if(that.active_study && that.active_study.etudeData && !!that.active_study.etudeData.refreshQlikData){
			that.refreshing_stats = true;
		}
		if(that.active_study && that.active_study.etudeData && !!that.active_study.etudeData.refreshKyaneosData){
			that.refreshing_kyaneos = true;
		}
		if(that.active_study && that.active_study.etudeData && !!that.active_study.etudeData.refreshYanportData){
			that.refreshing_yanport = true;
		}
		this.$store.dispatch("launch_saving_interval");
		Bus.$on("global-click", function () {
			that.more_menu = false;
		});
		// définition de la durée entre deux sauvegardes ici
	},
	beforeDestroy: function () {
		this.$store.dispatch("stop_saving_interval");
	},
	components: { Page, Sidebar, StaticStudy }
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/app'
@import '../../assets/css/grid'
 
 .save-required {
	background-color: orange
 }
 .save-done {
	background-color: green
 }
.fade-enter-active, .fade-leave-active {
  transition: all .3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-100px);
}

.study
	height 100%
	.study-content
		height 100%
	.study-loading
		position absolute
		left 50%
		top 50%
		margin-left -20px
		margin-top -20px
		animation rotate 1s infinite linear
		color #fff
	.row-boxes
		height 100%
		> .col
			height 100%
			&.col-sidebar
				width 400px
				display flex
				flex-direction column
			&.col-editor
				width calc(100% - 400px)
				&.editing
					width 100%
			&.col-static
				width calc(100% - 400px)
	.study-dates
		margin-top 16px
		right 0
		bottom 0
		font-size 11px
		line-height 16px
		color #999
		.study-date
			padding 16px
			background-color darken(dark, 25%)
			border-radius radius
			&:hover
				.hover
					opacity 1
			p
				display block
				white-space nowrap
				.label
					display block
				.value
					display block
					font-weight 500
					color #ccc
			.hover
				opacity 0
				position absolute
				left 0
				top 0
				right 0
				bottom 0
				display flex
				align-items center
				justify-content center
				flex-direction column
				padding 16px 16px 16px 56px
				background-color green
				cursor pointer
				border-radius radius
				color #fff
				font-weight 500
				font-size 12px
				text-align left
				> .icon
					position absolute
					left 16px
					top 20px
					display block
					&.rotate
						animation rotate 1.25s infinite linear
		.study-date.refresh-qlik
			.hover
				opacity 1
	.mode-switcher-info
		position absolute
		left 50%
		top 0px
		height 40px
		padding 0 24px
		border-radius @height
		background-color #111
		transform translateX(-50%)
		white-space nowrap
		line-height @height
		font-size 12px
		color #fff
		font-weight 500
		z-index 10001
		&.mode-switcher-enter-active, &.mode-switcher-leave-active
			transition transform 0.25s easeOutQuart
		&.mode-switcher-enter, &.mode-switcher-leave-to
			transform translateX(-50%) translateY(-200%)


.box-editor
	height calc(100% + 32px)
	margin -16px -16px -16px 0
	background transparent
	.content
		height 100%

.user-menu
	position fixed
	right 32px
	top 32px
	z-index 10004
	.save-button, .print-button
		&.loading
			top 0
			right 0
	.mode-button, .print-button, .save-button
		display block
		width 80px
		height 80px
		margin-bottom 16px
		perspective 1000px
		&:first-child
			margin-bottom 16px
		&.show-back .button-content
			transform rotateY(180deg)
		&.loading
			.button-content
				.button.back, .button.front
					.button-loader
						display block
		.button-content
			position relative
			width 100%
			height 100%
			text-align center
			transition transform 0.5s easeOutQuart
			transform-style preserve-3d
			border-radius 100%
			&:hover
				&+ .tooltip
					display flex
			.button.readonly
				opacity 0.4
				cursor default
			.button.back, .button.front
				position absolute
				left 0
				top 0
				width 80px
				height 80px
				backface-visibility hidden
			.info.back, .info.front
				position absolute
				left 0
				top 0
				width 80px
				height 80px
				backface-visibility hidden
			.button.front
				transform rotateY(0deg)
			.button.back
				transform rotateY(180deg)
			.info.front
				transform rotateY(0deg)
			.info.back
				transform rotateY(180deg)
			.info
				display block
				width 80px
				height 80px
				padding 24px
				color #fff
				border-radius 100%
				cursor auto
				&.light
					background-color light
					color dark
					box-shadow 0 0 2px alpha(dark, 50%)
					.button-loader
						background-color light
						color dark
				&.blue
					background-color blue
					// &:hover
					// 	background-color darken(blue, 10%)
					.button-loader
						background-color blue
						// &:hover
						// 	background-color darken(blue, 10%)
				&.green
					color green
					background-color transparent
					// &:hover
					// 	background-color darken(green, 10%)
					.button-loader
						background-color green
						// &:hover
						// 	background-color darken(green, 10%)
				&.orange
					color orange
					background-color transparent
					// &:hover
					// 	background-color darken(orange, 10%)
					.button-loader
						background-color orange
						// &:hover
						// 	background-color darken(orange, 10%)
				&.red
					color red
					background-color transparent
					.button-loader
						background-color red
				.icon
					display block
				.button-loader
					display none
					position absolute
					left 0
					top 0
					height 80px
					width 80px
					padding 24px
					border-radius 100%
					color #fff
					.icon
						display block
						animation rotate 2s linear infinite
			.button
				display block
				width 80px
				height 80px
				padding 24px
				color #fff
				border-radius 100%
				cursor pointer
				&.light
					background-color light
					color dark
					box-shadow 0 0 2px alpha(dark, 50%)
					.button-loader
						background-color light
						color dark
				&.blue
					background-color blue
					&:hover
						background-color darken(blue, 10%)
					.button-loader
						background-color blue
						&:hover
							background-color darken(blue, 10%)
				&.low-opacity
					background-color darken(green, 10%)
					opacity 0.3
					cursor auto
				
				&.green
					background-color green
					&:hover
						background-color darken(green, 10%)
					.button-loader
						background-color green
						&:hover
							background-color darken(green, 10%)
				&.orange
					background-color orange
					&:hover
						background-color darken(orange, 10%)
					.button-loader
						background-color orange
						&:hover
							background-color darken(orange, 10%)
				.icon
					display block
				.button-loader
					display none
					position absolute
					left 0
					top 0
					height 80px
					width 80px
					padding 24px
					border-radius 100%
					color #fff
					.icon
						display block
						animation rotate 2s linear infinite
		.tooltip
			position absolute
			top 50%
			right calc(100% + 12px)
			// height 32px
			padding 8px 16px
			transform translateY(-50%)
			border-radius radius
			background-color #222
			color #fff
			line-height 16px
			display flex
			display none
			align-items center
			justify-content center
			align-content center
			white-space nowrap
			font-size 12px
			font-weight 500
			&:before
				content ''
				position absolute
				top 50%
				right -8px
				margin-top -8px
				width 0
				height 0
				border-style solid
				border-width 8px 0 8px 8px
				border-color transparent transparent transparent #222
		.more
			position absolute
			left 50%
			bottom -28px
			margin-left -16px
			width 32px
			height 32px
			padding 8px 8px
			background-color #222
			color #fff
			border-radius 0 0 100% 100%
			cursor pointer
			transition transform 0.25s easeOutQuart
			transform translateY(-4px)
			&:hover
				background-color #000
				transform translateY(0)
			&.visible
				box-shadow 0 0 0 2px dark
				transform translateY(0)
			.icon
				display block
				transform translateY(2px)
				text-align center
		.more-menu
			position absolute
			right 0
			top calc(100% + 20px)
			padding 12px
			background-color #222
			border-radius radius
			color #fff
			white-space nowrap
			font-size 12px
			// font-weight 500
			&:before
				// content ''
				position absolute
				top -8px
				right 32px
				width 0
				height 0
				border-style solid
				border-width 0 8px 8px 8px
				border-color transparent transparent #222 transparent
			.action
				padding 8px 12px 8px 40px
				cursor pointer
				line-height 16px
				border-radius radius
				color #999
				&:hover
					color #fff
					background-color dark
				.icon
					position absolute
					left 12px
					top 50%
					margin-top -8px
.pdf-menu
	position absolute
	right 32px
	bottom 32px
	.button
		display flex
		align-items center
		justify-content center
		align-content center
		width 80px
		height 80px
		border-radius 100%
		background-color #ea4c3a
		overflow hidden
		cursor pointer
		.icon
			display block
	.button-publish
		display flex
		align-items center
		justify-content center
		align-content center
		width 80px
		height 80px
		border-radius 100%
		background-color green
		color white
		overflow hidden
		cursor pointer
		.icon
			display block

.pages
	padding 32px 96px 32px 0
	display flex
	flex-direction column
	align-items center
	.page
		margin 0 0 24px 0
		&:last-child
			margin-bottom 0

.card-publication
	padding 8px
	.loading-pub-study
		width 560px
		height 256px
		display flex
		flex-direction column
		align-items center
		justify-content center
		cursor progress
		.icon
			margin-bottom 16px
		.rotate
			animation rotate 1.5s infinite linear
		.main
			text-transform uppercase
			height auto
		.failed
			color red
		.sub
			font-style italic
			height auto
			font-size 12px
			opacity 0.8
		.button
			padding 8px
			background-color #303030
			border-radius 4px
			font-size 11px
			line-height 16px
			color white
			width 64px
			text-align center
			margin-top 16px
		.button:hover
			opacity 0.8
			cursor pointer
			background-color green
</style>